<div
    *ngIf="user$ | async; let user; else: loading"
    class="login-top-part-wrapper"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-image': 'url(assets/images/login-bg.jpg)' }"
>
    <button class="logout-btn" mat-icon-button i18n-matTooltip="@@logout" matTooltip="Logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
    </button>
    <div class="layer"></div>
    <app-chat-io-payment-manager
        *ngIf="subscriptionPlans$ | async; let subscriptionPlans"
        [stepIndex]="user.subscription_plan_id ? 1 : 0"
        [subscriptionPlans]="subscriptionPlans"
        [subscriptionPlanId]="user.subscription_plan_id"
        [isLoading$]="isLoading$"
        (paymentSucceeded)="onPaymentSucces($event)"
    ></app-chat-io-payment-manager>
</div>
<ng-template #loading>
    <app-kd-logo-loading></app-kd-logo-loading>
</ng-template>
